import RouteTemplate from 'ember-route-template'
import type FastPhonicsReportingProgressStudentRoute from 'teacher-ui-client/reporting/ui-scope/fast-phonics/progress/student/route'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { ReportingStudentSummaryControls } from 'teacher-ui-client/components/reporting/student-summary-controls'
import { ReportingNoDataMessageIf } from 'teacher-ui-client/components/reporting/no-data-message-if'
import { StatBoxesTile } from 'teacher-ui-client/components/tiles/stat-boxes'
import { PeaksProgressComponent } from 'teacher-ui-client/components/stat-boxes/peaks-progress'
import { ContentTile } from 'teacher-ui-client/components/tiles/content'
import Component from '@glimmer/component'
import { service } from '@ember/service'
import type TableToCsv from 'teacher-ui-client/services/table-to-csv'
import { isEmpty } from '@ember/utils'
import { reportingFilename } from 'teacher-ui-client/utils/filename'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { not } from 'ember-truth-helpers'
import { t } from 'ember-intl'

interface Signature {
  model: ModelFor<FastPhonicsReportingProgressStudentRoute>
}
export class FpProgressStudentPage extends Component<Signature> {
  @service tableToCsv!: TableToCsv

  get noData() {
    return isEmpty(this.args.model.peaksProgressDetails)
  }

  get exportOptions() {
    const filename = `${reportingFilename(
      'fast-phonics-student-progress',
      this.args.model.student.fullName,
      this.args.model.period,
    )}.csv`
    return [
      {
        exportType: ExportType.CSV,
        exportAction: () => this.tableToCsv.downloadCsvFrom('[exportable]:not([exportable=false])', { filename }),
      },
      { exportType: ExportType.print },
    ]
  }

  <template>
    <ReportingTeacherUiHeader
      @title={{t "reporting.fastPhonics.peaksProgress.student.pageTitle" studentName=@model.student.fullName}}
      @returnLinkText={{t "reporting.fastPhonics.peaksProgress.student.returnLink"}}
      @returnLinkRoute="reporting.ui-scope.fast-phonics.progress.review.students"
    />

    <ReportingStudentSummaryControls
      @students={{@model.students}}
      @student={{@model.student}}
      @exportOptions={{this.exportOptions}}
      @isDataPresent={{not this.noData}}
      @studentRouteName="reporting.ui-scope.fast-phonics.progress.student.table"
      @allStudentsRouteName="reporting.ui-scope.fast-phonics.progress.review.students"
    />

    <ReportingNoDataMessageIf @on={{this.noData}}>
      {{#if @model.peaksProgressDetails.summary}}
        <div class="text-center">
          <StatBoxesTile class="page-break-after-always inline-block">
            <PeaksProgressComponent @data={{@model.peaksProgressDetails.summary}} @scope="student" />
          </StatBoxesTile>
        </div>
      {{/if}}

      <ContentTile class="page-break-inside-auto mt-6 print:border-none">
        <div class="overflow-x-auto print:overflow-x-hidden">
          {{outlet}}
        </div>
      </ContentTile>

    </ReportingNoDataMessageIf>
  </template>
}

export default RouteTemplate(FpProgressStudentPage)
